import { isDiversionValid } from "../../../SystemSettingsStagingDiversion/SystemSettingsStagingDiversion.utils";
import {
  type DataprocStagingEntry,
  dataprocStagingSchema,
} from "./DataprocStagingIntegrationForm.types";

export const emptyDataprocStaging = (): DataprocStagingEntry =>
  dataprocStagingSchema.parse({});

export const isGcpServiceAccount = (value: string) =>
  value.trim().endsWith(".gserviceaccount.com");

export const canSaveDataproc = (entry: DataprocStagingEntry) =>
  !!entry.project_id.trim() &&
  isGcpServiceAccount(entry.run_as_service_account) &&
  isDiversionValid(entry, "gs://");
